import { CheckCircle, Warning } from "@mui/icons-material";
import { IconButton, Tooltip } from "@mui/material";

type Props =
  | {
      status: "success";
    }
  | {
      status: "warning";
      onNavigate: () => void;
      title: string;
    };

const StatusBadge = (props: Props) => {
  const { status } = props;

  if (status === "warning") {
    return (
      <Tooltip
        title={props.title}
        slotProps={{
          tooltip: {
            sx: {
              fontSize: "0.95rem",
            },
          },
        }}
      >
        <IconButton size="small" onClick={props.onNavigate}>
          <Warning color="warning" fontSize="large" />
        </IconButton>
      </Tooltip>
    );
  }

  if (status === "success") {
    return (
      <Tooltip
        title="All information is up to date"
        slotProps={{
          tooltip: {
            sx: {
              fontSize: "0.95rem",
            },
          },
        }}
      >
        <CheckCircle color="success" fontSize="large" />
      </Tooltip>
    );
  }
};

export default StatusBadge;
